import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { StripeExpressCheckoutComponentDef } from '@df/module-stripe/stripe-express-checkout.component.def';
import { CheckoutFormComponent } from '../../checkout/checkout-form.component';
import { CheckoutStepComponent } from '../../checkout/checkout-step.component';

@Component({
    selector: 'stripe-express-checkout',
    templateUrl: './stripe-express-checkout.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StripeExpressCheckoutComponent extends StripeExpressCheckoutComponentDef implements OnInit {
    constructor(
        protected override checkoutFormComponent: CheckoutFormComponent,
        protected _ref: ChangeDetectorRef,
        protected scrollService: ScrollToService,
        protected checkoutStepcomponent: CheckoutStepComponent
    ) {
        super(checkoutFormComponent, _ref, scrollService, checkoutStepcomponent);
    }
}
